import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface RegisterState {
  checking: boolean;
  available: boolean | null;
  error: { message: string } | null;
}

export const initialRegisterState: RegisterState = {
  checking: false,
  available: null,
  error: null,
};

export const selectRegister = createFeatureSelector<RegisterState>('register');

export const selectChecking = createSelector(selectRegister, s => s.checking);
export const selectAvailable = createSelector(selectRegister, s => s.available);
export const selectCheckError = createSelector(selectRegister, s => s.error);